export const SOCIAL_PLATFORMS = [
  { value: "facebook", label: "Facebook" },
  { value: "instagram", label: "Instagram" },
  { value: "twitter", label: "X (Twitter)" },
  { value: "linkedin", label: "LinkedIn" },
  { value: "gmb", label: "GMB (Google Business Profile)" },
  { value: "youtube", label: "YouTube" },
  { value: "whatsapp", label: "WhatsApp Business" },
  { value: "gmail", label: "Gmail / Google Account" },
];

/** Older values no longer offered in the dropdown but still on saved accounts. */
const LEGACY_PLATFORMS = [{ value: "google", label: "Gmail / Google Account" }];

export const SOCIAL_PLATFORM_VALUES = SOCIAL_PLATFORMS.map((p) => p.value);

export function socialPlatformLabel(value) {
  const match = [...SOCIAL_PLATFORMS, ...LEGACY_PLATFORMS].find((p) => p.value === value);
  return match ? match.label : value;
}

/** Platforms with a separate business page / listing link next to the profile (Business_URL). */
export const PLATFORMS_WITH_PAGE_URL = ["facebook", "linkedin", "gmb"];

/** Social account login / ownership / security options (API: services/social_account_details.py). */
export const LOGIN_OWN = "Own login";
export const LOGIN_METHODS = [LOGIN_OWN, "Sign in with Google", "Sign in with Facebook"];
export const ACCESS_TYPES = ["Client credentials", "Our admin access", "Partner access"];
export const ACCOUNT_OWNERS = ["Client", "Agency"];
export const VERIFICATION_STATUSES = ["Verified", "Pending", "Not verified"];
export const TWO_FA_METHODS = ["SMS", "Authenticator app", "Email"];
export const SOCIAL_ACCOUNT_STATUSES = ["Active", "Inactive", "Suspended"];

const withQuery = (base, params) => {
  const query = new URLSearchParams(Object.entries(params).filter(([, v]) => v)).toString();
  return query ? `${base}?${query}` : base;
};

const googleSignIn = (continueUrl) => (login) =>
  withQuery("https://accounts.google.com/AccountChooser", { Email: login, continue: continueUrl });

/**
 * Login page per platform, given the account's Username (never Email_Used). Facebook and Google pre-fill it
 * through their own query names (``email`` / ``Email``); the others ignore it.
 */
const LOGIN_PAGES = {
  facebook: (login) => withQuery("https://www.facebook.com/login/", { email: login }),
  instagram: () => "https://www.instagram.com/accounts/login/",
  twitter: () => "https://x.com/i/flow/login",
  linkedin: () => "https://www.linkedin.com/login",
  gmb: googleSignIn("https://business.google.com/"),
  youtube: googleSignIn("https://studio.youtube.com/"),
  gmail: googleSignIn("https://mail.google.com/"),
  google: googleSignIn("https://myaccount.google.com/"),
};

export function socialLoginUrl(platform, login) {
  const page = LOGIN_PAGES[platform];
  return page ? page(String(login || "").trim()) : null;
}

/** Platforms whose accounts can be used to sign in to others ("Sign in with Google / Facebook"). */
export const LOGIN_PROVIDER_PLATFORMS = {
  "Sign in with Google": ["gmail", "google"],
  "Sign in with Facebook": ["facebook"],
};

/** Connection status set by hand on a Social Connection (API: SOCIAL_CONNECTION_STATUSES). */
export const SOCIAL_CONNECTION_STATUSES = ["Not connected", "Connected", "Expired"];

export function connectionStatusBadgeClass(status) {
  if (status === "Connected") return "cportal-badge cportal-badge--success";
  if (status === "Expired") return "cportal-badge cportal-badge--danger";
  return "cportal-badge";
}
